let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jtXvi")).then(() => parcelRequire('bCdSC'));